import { memo } from 'react';
import cn from 'classnames';
import type { ChatListFilter } from '../../model/types';
import { IconAllChats, IconArchive, IconGroup, IconPersonal } from '../icons';

export type ChatFilterBarProps = {
  filter: ChatListFilter;
  onFilterChange: (f: ChatListFilter) => void;
};

const FILTERS: { key: ChatListFilter; label: string; Icon: typeof IconAllChats }[] = [
  { key: 'all', label: 'All', Icon: IconAllChats },
  { key: 'personal', label: 'Personal', Icon: IconPersonal },
  { key: 'group', label: 'Group', Icon: IconGroup },
  { key: 'archived', label: 'Archived', Icon: IconArchive },
];

export const ChatFilterBar = memo(({ filter, onFilterChange }: ChatFilterBarProps) => (
  <div className="flex shrink-0 justify-start p-0 mb-6">
    <div className="inline-flex w-fit rounded-xl gap-1">
      {FILTERS.map(({ key, label, Icon }) => {
        const active = filter === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onFilterChange(key)}
            className={cn(
              'inline-flex items-center justify-center gap-2 rounded-md px-3 py-2 text-small font-medium transition-colors cursor-pointer',
              active
                ? 'bg-foreground text-background shadow-sm'
                : 'text-[#B3B3B3] hover:text-foreground',
            )}
          >
            <Icon className="shrink-0" />
            <span className="hidden min-[400px]:inline">{label}</span>
          </button>
        );
      })}
    </div>
  </div>
));

ChatFilterBar.displayName = 'ChatFilterBar';
